'use strict';
var customUtil = require('../customUtil.js');
var mobileMax = 992;

/** Fix header on scroll*/
var stickyHeader = function () {
    var scrollTop = $(window).scrollTop();
    var header = $('.sticky-header');
    var headerBanner = $('.header-banner');
    var headerBannerNegativeHeight = headerBanner.innerHeight() * -1;
    if (scrollTop > 0) {
        if (scrollTop > $('.fixed-header').innerHeight()) {
            header.css('margin-top', headerBannerNegativeHeight);
            headerBanner.css('top', headerBannerNegativeHeight);
        } else {
            header.css('margin-top', 0);
            headerBanner.css('top', 'auto');
        }
        $('body').css('paddingTop', $('.sticky-header').innerHeight());
        $('.back-to-top').fadeIn();
    } else {
        header.css('margin-top', 0);
        headerBanner.css('top', 'auto');
        $('body').css('paddingTop', 0);
        $('.back-to-top').fadeOut();
        // Readjustment of padding once fixed-header is used
        setTimeout(addFirstChildPadding, 200);
    }
};

/**
 * @param {Element} element js element
 * @returns {boolean} if element is in view
 */
function isInViewport(element) {
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
}

/**
 * initialize the promo carousel in the header banner
 */
function initPromoCarousel() {
    $('.header-carousel-slider').on('init', function () {
        var $headerBanner = $('.header-banner');
        if (isInViewport($headerBanner.get(0))) {
            $('.storepage, .main-content *:not(script):first').css('margin-top', $('.js-page').innerHeight() + 'px');
        } else {
            $('.storepage, .main-content *:not(script):first').css('margin-top', $('.js-page').innerHeight() + $headerBanner.innerHeight() + 'px');
        }
        $headerBanner.css('opacity', 1);
    });

    $('.header-carousel-slider').slick({
        autoplay: false,
        arrows: true,
        dots: false,
        speed: 500
    });

    $('.header-carousel-slider').on('beforeChange', function() {
        var $headerBanner = $('.header-banner');
        if (isInViewport($headerBanner.get(0))) {
            $('.storepage, .main-content *:not(script):first').css('margin-top', $('.js-page').innerHeight() + 'px');
        } else {
            $('.storepage, .main-content *:not(script):first').css('margin-top', $('.js-page').innerHeight() + $headerBanner.innerHeight() + 'px');
        }
    });

    var maxHeight = -1;
    var $slickSlide = $('.header-carousel-slider .slick-slide');

    /* search and get the max height of the slick slides */
    $slickSlide.each(function () {
        if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        }
    });

    /* calculate the highest slide and set a top/bottom margin for other children. */
    $slickSlide.each(function () {
        if ($(this).height() < maxHeight) {
            $(this).css('margin', Math.ceil((maxHeight - $(this).height()) / 2) + 'px 0');
        }
    });
}

/**
 * Adds padding to first element of main content if promo carousel is unavailable
 */
function addFirstChildPadding() {
    var $headerBanner = $('.header-banner');
    var $firstChild = $('.storepage, #maincontent *:not(script)')
        .filter(function() {
            return $(this).is(":visible") && $(this).outerWidth() > 0 && $(this).outerHeight() > 0;
        })
        .first();
    if (customUtil.isMobile() && $(window).width() <= mobileMax) {
        $firstChild.css('margin-top', 0);
    } else if ($('.fixed-header').css("position") === "fixed") {
        if (isInViewport($headerBanner.get(0))) {
            $firstChild.css('margin-top', $('.fixed-header').innerHeight() + 'px');
        } else {
            $firstChild.css('margin-top', $('.fixed-header').innerHeight() + $headerBanner.innerHeight() + 'px');
        }
    } else {
        $firstChild.css('margin-top', 0);
    }
    $headerBanner.css('opacity', 1);
}

function onResize() {
    if (!customUtil.isMobile()) {
        $(window).on('scroll', function () {
            stickyHeader();
        });
    }
    addFirstChildPadding();
}

/** Document on Ready*/
function onReady() {
    if ($('.header-carousel-slider').length > 0) {
        setTimeout(initPromoCarousel, 500);
    } else {
        setTimeout(addFirstChildPadding, 500);
    }
    onResize();
}

module.exports = function () {
    $(window).on('resize', onResize);
    $(document).ready(onReady);
    $('.header-carousel-slider').on('init', addFirstChildPadding);

    $(document).ready(() => {
        var $headerBanner = $('.header-banner .html-slot-container');
        if ($headerBanner.length < 1) $('.header-banner').hide();
    });
}
